import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock } from "vue"


import CancelIcon from "@/components/icons/CancelIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  props: {
    show: { type: Boolean },
    showCancelIcon: { type: Boolean, default: true },
    variant: { default: "center" },
    containerClass: { default: "bg-white" },
    maxModalSizeClass: { default: "max-w-sm" }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const closeModal = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-300 ease-out",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[200]", [__props.variant === 'center' ? 'p-4' : 'pt-20']]),
          onClick: _withModifiers(closeModal, ["self"])
        }, [
          _createVNode(_Transition, {
            "enter-active-class": "transition duration-300 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-200 ease-in",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: _withCtx(() => [
              (__props.show)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["rounded-lg w-full p-4", [
              __props.containerClass,
              __props.variant === 'center' ? __props.maxModalSizeClass : 'h-full flex flex-col',
            ]])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex items-center mb-4", { 'justify-between': __props.showCancelIcon }])
                    }, [
                      _renderSlot(_ctx.$slots, "header", {}, () => [
                        _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1))
                      ]),
                      (__props.showCancelIcon)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: closeModal,
                            class: "w-[30px] h-[30px] bg-ternary rounded-full shrink-0"
                          }, [
                            _createVNode(CancelIcon, { class: "text-brown mx-auto" })
                          ]))
                        : _createCommentVNode("", true)
                    ], 2),
                    _renderSlot(_ctx.$slots, "content")
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ], 2), [
          [_vShow, __props.show]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})